import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmOfferProjectStatusState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmOfferProjectStatusState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmOfferProjectStatusSlice = createSlice({
  name: 'pmOfferProjectStatus',
  initialState,
  reducers: {
    setPmOfferProjectStatuses: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmOfferProjectStatusesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmOfferProjectStatusesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmOfferProjectStatuses, setPmOfferProjectStatusesLoading, setPmOfferProjectStatusesError } =
  PmOfferProjectStatusSlice.actions;

export default PmOfferProjectStatusSlice.reducer;
